export default "__VITE_ASSET__68a81628__"